import * as React from 'react';

import { clsx } from '@freelancelabs/utils';

interface Props extends React.ThHTMLAttributes<HTMLTableCellElement> {
    children?: React.ReactNode;
    type?: 'body' | 'footer';
    className?: string;
    mouseDown?: string;
}

const TableCell = ({ children, className, type = 'body', mouseDown, id, ...rest }: Props) => {
    if (type === 'footer') {
        return (
            <th scope="col" {...rest}>
                {children}
            </th>
        );
    }

    return (
        <td className={clsx(className, 'fl-table-cell', mouseDown === id && 'fl-table-cell-down')} {...rest}>
            {children}
        </td>
    );
};

export default TableCell;
